import styled from 'styled-components';

export const StyledScriptContent = styled.div``;
